import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class GuestGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate() {
    const isAuth = this.authService.isAuth();

    if (isAuth) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}
